import type { FreelancerDiplomasYearSelectionPageLocales } from '../types';

const freelancerDiplomasYearSelectionPageLocales: FreelancerDiplomasYearSelectionPageLocales =
  {
    foreignDiploma: 'Buitenlands diploma',
    helperMessage: 'Selecteer de situatie die op jou van toepassing is.',
    nlDiplomaAfter2007: 'Nederlands diploma na 2007',
    nlDiplomaFor2008: 'Nederlands diploma voor 2007',
    title: 'Selecteer diplomajaar',
  };

export default freelancerDiplomasYearSelectionPageLocales;
